export default {
    teacher: [],
    active_teacher: [],
    teacher_chekout: []
}